export default [
  {
    path: '/contratos',
    name: 'contratos',
    component: () => import(/* webpackChunkName: "contratos" */ '@/pages/contratos/ContratosPage.vue'),
    meta: { requiresAuth: true },
  },
]
